import { ISingleEpletMmRisk } from '..';
import { IListItem } from '../list-item'

export interface IDonorProfileDeclinesData {
    donorId: number,
    donorAlias: string,
    acceptedCount: number,
    declinesByReasonList: IDeclineReasonCount[],
    declineCommentsList: IDeclineComment[],
    hardBlockReasonList: IListItem[]
}

export interface IDeclineReasonCount {
    reason: string,
    reasonCount: number
}

export interface IDeclineComment {
    id: number,
    decisionDateTime: string,
    hardBlockComments: string,
    userName: string
}

export interface IDonorProfileAcceptsData {
    donorId: number,
    donorAlias: string,
    acceptedList: IAccepted[],
    canOrderCryo: boolean
}

export interface IAccepted {
    id: number,
    decisionDateTime: string,
    userName: string,
    recipientAlias: string,
    recipientIsActive: boolean,
    recipientIsExportable: boolean,
    recipientStatusId: number,
    recipientStatus: string,
    recipientCenter: string,
    recipientType: string
}


export interface IDonorProfilePreSelectLogData {
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    preselectLogs: IPreselectLogs[],
    canOrderCryo: boolean
}

export interface IPreselectLogs {
    id: number,
    recipientType: string,
    recipientTypeId: number,
    recipientAlias: string,
    recipientCenter: string,
    recipientCenterId: number,
    roundedCpra4: number,
    recipientAge: number,
    recipientBloodType: string,
    recipientIsActive: boolean,
    recipientIsExportable: boolean,
    recipientStatusId: number,
    recipientStatus: string,
    decisionDateTime: string,
    dialysisMonths: number,
    applicableWaitTime: string,
    declineRatio: string,
    declineRatioHistoric: string,
    declineRatioCurrent: string,
    highestDeclineRatio: string,
    forecastedWaitTime: string,
    epletMm: ISingleEpletMmRisk,
    isAccepted: boolean | null,
    isReEvalNeeded: boolean,
    donorPreselectDecision: string
}